<template>
  <div class="modal-container" ref="modalContainer">
    <div class="form-content-body" >
      <div>
        <div class="row no-gutters">
          <div class="col-md-12 text-center modal-header align-items-center">
            <div class="header-container row no-gutters justify-content-between w-100 px-4">
              <h3 class="text-center">Close {{ record.caseNumber }}</h3>
              <button class="close close-btn" :disabled="isLoading" @click="$emit('close')">
                <img src="../assets/images/icon-close.svg" />
              </button>
            </div>
          </div>
        </div>
        <div class="row no-gutters close-case-container">
          <div class="overlay-loader-container" v-if="isLoading">
            <img class="overlay-loader loading-spinner" :src="CONSTANTS.SPINNER_URL" alt="Loading Spinner">
          </div>

          <div class="col-12" v-else>
            <div class="alert-container mb-2" v-if="errorMessage">
              <div class="fade-in-out alert alert-error" >
                <div><strong>{{errorMessage}}</strong></div>
              </div>
            </div>

            <div class="close-comments-container">
              <div class="required-field">Close comment</div>
              <div class="text-muted">Comment will appear on the case as close notes.</div>
              <textarea
                  class="w-100 close-comments mt-2 p-1"
                  v-model="closeComments"
                  v-validate="'required'"
                  data-vv-validate-on="input"
                  name="closeComments"
              ></textarea>
              <div class="text-danger input-error-text" v-if="errors.has('closeComments')">
                This field is required.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row buttons-group no-gutters justify-content-end pb-2 px-md-0 px-3 ml-md-0 ml-3" v-if="!isLoading">
        <button class="btn-container flat-btn gray-btn close-btn btn mx-2 mx-3" @click="$emit('close')">Cancel</button>
        <button class="btn-container btn flat-btn submit-btn mr-md-4 mx-md-0 mx-3 mt-md-0 mt-3" @click="closeRITMCase">Close case</button>
      </div>
    </div>

  </div>
</template>

<script>
import api from "@/api";
import CONSTANTS from "@/store/constants";
import { mapGetters } from "vuex"
export default {
  name: "CloseRITMModal",
  props: ["record"],
  data() {
    return {
      closeComments: "",
      isLoading: false,
      errorMessage: ''
    }
  },
  created() {
    this.errorMessage = ''
  },
  computed: {
    ...mapGetters(["currentUser"])
  },
  methods: {
    async closeRITMCase() {
      const isValidationSuccess = await this.$validator.validateAll()
      if(isValidationSuccess) {
        this.isLoading = true
        let retryCount = 0
        let response = {}
        let isTooManyRequests = false
        do {
          try {
            response = await api.closeSupplierOnBoardRequestById(this.record.caseId, this.closeComments)
          } catch (e) {
            if(e && e.response && e.response.status === 429 && retryCount < CONSTANTS.MAX_RETRY_COUNT) {
              isTooManyRequests = true
              retryCount++
              await new Promise(r => setTimeout(r, CONSTANTS.RETRY_INTERVAL_IN_MILLIS));
            } else {
              isTooManyRequests = false
              this.isLoading = false
              this.errorMessage = CONSTANTS.ERROR_MESSAGE
            }
          } finally {
            if(!isTooManyRequests) {
              this.isLoading = false
              if(response && response.data && response.data.result) {
                this.$parent.$emit('onClosed', true)
              } else {
                this.errorMessage = CONSTANTS.ERROR_MESSAGE
              }
            }
          }
        } while(retryCount <= CONSTANTS.MAX_RETRY_COUNT && isTooManyRequests)

      }
    }
  }

}
</script>

<style scoped>
.modal-container {
  background-color: #fff;
  overflow-y: auto !important;
  height: 100%;
  overflow-x: hidden;
}

.close-case-container {
  padding: 20px;
}

.close-comments {
  resize: none;
  min-height: 90px;
}

.overlay-loader {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.overlay-loader-container {
  height: 220px;
  width: 100%;
}

.modal-container {
  padding-bottom: 20px;
}


@media (max-width: 800px) {
  .modal-container {
    height: 55vh;
  }
}

.form-content-body {
  height: 100%;
}

.flat-btn {
  margin-top: 0px;
}


.btn-container {
  margin-bottom: 0;
}

.close-comments-container {
  min-height: 175px;
}
</style>